import { capitalizeFirstLetter, getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from "../../../EditablePreview/EditablePreview";
import { useEffect, useState } from 'react';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";

const AnimationModule = (props) => {
    console.log("AnimationModule:", props);

    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;
    const campaignData = props.campaignData;
    const selectedFeatureNode = props.selectedFeatureNode;

    let tweenFieldConfig = null;
    let durationFieldConfig = null;
    let delayFieldConfig = null;
    let easingFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('animation-tween')) {
            tweenFieldConfig = field;
        } else if (field.field.includes('animation-duration')) {
            durationFieldConfig = field;
        } else if (field.field.includes('animation-delay')) {
            delayFieldConfig = field;
        } else if (field.field.includes('animation-easing')) {
            easingFieldConfig = field;
        }
    }

    let tweenOptions = null;
    if (tweenFieldConfig?.dataLink) {
        tweenOptions = getCustomisationFieldData(campaignData, selectedFeatureNode.path, tweenFieldConfig.dataLink);
        console.log("AnimationModule Tween options:", tweenOptions);
    }
    const tweenFieldValue = getCustomisationValue(customisationVars, tweenFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || tweenOptions?.default || 'fade';
    console.log("AnimationModule Tween field value:", tweenFieldValue);
    let displayedTweenValue = capitalizeFirstLetter(tweenFieldValue);
    for (let i = 0; i < tweenOptions?.valOptions?.length; i++) {
        if (tweenOptions.valOptions[i].value === tweenFieldValue || tweenOptions.valOptions[i].val === tweenFieldValue || String(tweenOptions.valOptions[i].value) === String(tweenFieldValue) || String(tweenOptions.valOptions[i].val) === String(tweenFieldValue)) {
            displayedTweenValue = capitalizeFirstLetter(tweenOptions.valOptions[i].label);
        }
    }
    const changeTweenFieldValue = (fieldId, value) => {
        if (changeStringFieldValue(customisationVars, tweenFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
            props?.forceUpdateComponent?.();
        }
    }

    let easingOptions = null;
    if (easingFieldConfig?.dataLink) {
        easingOptions = getCustomisationFieldData(campaignData, selectedFeatureNode.path, easingFieldConfig.dataLink);
        console.log("AnimationModule Easing options:", easingOptions);
    }
    const easingFieldValue = getCustomisationValue(customisationVars, easingFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || easingOptions?.default || 'circ';
    console.log("AnimationModule Easing field value:", easingFieldValue);
    let displayedEasingValue = capitalizeFirstLetter(easingFieldValue);
    for (let i = 0; i < easingOptions?.valOptions?.length; i++) {
        if (easingOptions.valOptions[i].value === easingFieldValue || easingOptions.valOptions[i].val === easingFieldValue || String(easingOptions.valOptions[i].value) === String(easingFieldValue) || String(easingOptions.valOptions[i].val) === String(easingFieldValue)) {
            displayedEasingValue = capitalizeFirstLetter(easingOptions.valOptions[i].label);
        }
    }
    const changeEasingFieldValue = (fieldId, value) => {
        console.log("AnimationModule Changing easing field value:", fieldId, value);
        if (changeStringFieldValue(customisationVars, easingFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
            props?.forceUpdateComponent?.();
        }
    }

    const durationFieldValue = getCustomisationValue(customisationVars, durationFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || '100';
    const changeDurationFieldValue = (fieldId, value) => {
        console.log("AnimationModule Changing duration field value:", fieldId, value);
        if (changeNumericalFieldValue(customisationVars, durationFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
            props?.forceUpdateComponent?.();
        }
    }
    const delayFieldValue = getCustomisationValue(customisationVars, delayFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || '0';
    const changeDelayFieldValue = (fieldId, value) => {
        console.log("AnimationModule Changing delay field value:", fieldId, value);
        if (changeNumericalFieldValue(customisationVars, delayFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
            props?.forceUpdateComponent?.();
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>{moduleConfig.name}</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column v2-full-width'>
                    <div className={`v2-module-field-label${tweenOptions?.valOptions?.length > 0 ? '' : ' disabled'}`}>Tween</div>
                    <ModuleTextInput
                        // fieldLabel="B"
                        value={displayedTweenValue}
                        fieldId={'animation-tween'}
                        enabled={tweenOptions?.valOptions?.length > 0}
                        editable={false}
                        onChange={changeTweenFieldValue}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={tweenOptions?.valOptions || []}
                        dropDownValue={tweenFieldValue}
                    />
                </div>
            </div>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column v2-full-width'>
                    <div className={`v2-module-field-label${easingOptions && easingOptions?.valOptions?.length > 0 ? '' : ' disabled'}`}>Easing</div>
                    <ModuleTextInput
                        value={displayedEasingValue}
                        fieldId={'animation-easing'}
                        enabled={easingOptions && easingOptions?.valOptions?.length > 0}
                        editable={false}
                        onChange={changeEasingFieldValue}
                        hiddenDropDown={easingOptions && easingOptions?.valOptions?.length > 0}
                        hiddenDropDownOptions={easingOptions?.valOptions || []}
                        dropDownValue={easingFieldValue}
                    />
                </div>
            </div>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!!durationFieldConfig?.dataLink ? '' : ' disabled'}`}>Duration (ms)</div>
                    <ModuleNumericalInput
                        // fieldLabel="ms"
                        value={durationFieldValue}
                        fieldId={'animation-duration'}
                        enabled={!!durationFieldConfig?.dataLink}
                        onChange={changeDurationFieldValue}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[50, 100, 250, 500, 1000]}
                        dropDownValue={durationFieldValue}
                    />
                </div>
                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!!delayFieldConfig?.dataLink ? '' : ' disabled'}`}>Delay (ms)</div>
                    <ModuleNumericalInput
                        // fieldLabel="ms"
                        value={delayFieldValue}
                        fieldId={'animation-delay'}
                        enabled={!!delayFieldConfig?.dataLink}
                        onChange={changeDelayFieldValue}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 50, 100, 250, 500, 1000]}
                        dropDownValue={delayFieldValue}
                    />
                </div>
            </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default AnimationModule;
